<template>
  <modal
    ref="addReport"
    :ok-disabled="loading"
    :ok-title="!$parent.id ? 'Pridať' : 'Upraviť'"
    :title="!$parent.id ? 'Pridať report' : 'Upraviť report'"
    cancel-title="Zrušiť"
    full-height
    name="add-consumer"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="$parent.saveReport"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" v-bar>
          <div>
            <b-form-group
              :label="
                'Obdobie ' +
                (energetic._measureType.const === 'MONTHLY' ? '(m/r)' : '(rok)')
              "
              label-cols-sm="5"
              label-for="period"
            >
              <single-date
                v-model="form.reportDate"
                v-validate="'required'"
                :format="measureTypeFormat"
                :class="{ 'is-invalid': errors.has('period') }"
                data-vv-as="Obdobie"
                name="period"
              />
              <b-form-invalid-feedback>
                {{ errors.first('period') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Množstvo VT (MWh)"
              label-cols-sm="5"
              label-for="amountVT"
            >
              <vue-autonumeric
                v-model="form.amountVT"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('amountVT') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 3,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="Množstvo VT"
                name="amountVT"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('amountVT') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Množstvo NT (MWh)"
              label-cols-sm="5"
              label-for="lossCoef"
            >
              <vue-autonumeric
                v-model="form.amountNT"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('amountNT') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 3,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="Množstvo NT"
                name="amountNT"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('amountNT') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Max. nam. výkon (kW)"
              label-cols-sm="5"
              label-for="measuredMax"
            >
              <vue-autonumeric
                v-model="form.measuredMax"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('measuredMax') }"
                class="form-control"
                data-vv-as="Max. nam. výkon"
                name="measuredMax"
              />
              <b-form-invalid-feedback>
                {{ errors.first('measuredMax') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Jalová dodávka (kVArh)"
              label-cols-sm="5"
              label-for="reactiveSupply"
            >
              <vue-autonumeric
                v-model="form.reactiveSupply"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('reactiveSupply') }"
                class="form-control"
                data-vv-as="Jalová dodávka"
                name="reactiveSupply"
              />
              <b-form-invalid-feedback>
                {{ errors.first('reactiveSupply') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="cos / tg φ" label-cols-sm="5" label-for="tg">
              <vue-autonumeric
                v-model="form.tg"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('tg') }"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 3,
                  emptyInputBehavior: 'null',
                }"
                class="form-control"
                data-vv-as="cos / tg"
                name="tg"
              />
              <b-form-invalid-feedback>
                {{ errors.first('tg') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Nedodržanie účinníka"
              label-cols-sm="5"
              label-for="failurePF"
            >
              <vue-autonumeric
                v-model="form.failurePF"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('failurePF') }"
                class="form-control"
                data-vv-as="Nedodržanie účinníka"
                name="failurePF"
              />
              <b-form-invalid-feedback>
                {{ errors.first('failurePF') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Prekročenie MRK (kW)"
              label-cols-sm="5"
              label-for="overMRK"
            >
              <vue-autonumeric
                v-model="form.overMRK"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('overMRK') }"
                class="form-control"
                data-vv-as="Prekročenie MRK"
                name="overMRK"
              />
              <b-form-invalid-feedback>
                {{ errors.first('overMRK') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Prekročenie RK (kW)"
              label-cols-sm="5"
              label-for="overRK"
            >
              <vue-autonumeric
                v-model="form.overRK"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('overRK') }"
                class="form-control"
                data-vv-as="Prekročenie RK"
                name="overRK"
              />
              <b-form-invalid-feedback>
                {{ errors.first('overRK') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Celková cena (€ bez dph)"
              label-cols-sm="5"
              label-for="totalPrice"
            >
              <vue-autonumeric
                v-model="form.totalPrice"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('totalPrice') }"
                class="form-control"
                data-vv-as="Celková cena"
                name="totalPrice"
                @change="sumPriceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('totalPrice') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Priem. jedn. cena (€ bez dph/MWh)"
              label-cols-sm="5"
              label-for="priceUnit"
            >
              <vue-autonumeric
                v-model="sumPriceUnit"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('priceUnit') }"
                class="form-control"
                data-vv-as="Priem. jedn. cena"
                disabled
                name="priceUnit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('priceUnit') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import SingleDate from '@/components/inputs/SingleDate'
import Modal from '@/components/Modal'
import { mapState } from 'vuex'

export default {
  components: {
    SingleDate,
    Modal,
  },
  data() {
    return {
      loading: false,
      form: {},
      month: null,
      year: null,
    }
  },
  computed: {
    ...mapState({
      energetic: (state) => state.energetic.current.data,
    }),
    measureTypeFormat() {
      if (this.energetic._measureType.const === 'MONTHLY') {
        return 'MM/YYYY'
      } else {
        return 'YYYY'
      }
    },
    sumPriceUnit: {
      get() {
        let total = this.form.totalPrice
        return total
          ? this.form.totalPrice / (this.form.amountVT + this.form.amountNT)
          : 0
      },
      set(val) {
        this.form.priceUnit = val
      },
    },
  },
  watch: {
    'form.reportDate': {
      immediate: true,
      handler(val) {
        if (this.measureTypeFormat === 'YYYY') {
          this.form.reportDate = `${this.$moment(val, 'YYYY').format('YYYY')}-12-31`
        }
      },
    },
  },
  methods: {
    fetchData() {
      this.form = {
        energetics_id: parseInt(this.$route.params.energetics_id),
      }
      if (this.$parent.id) {
        this.loading = true
        this.$api
          .get(`reports/${this.$parent.id}/consumer/get_form`)
          .then((res) => {
            this.form = res.data.data
            this.loading = false
          })
      }
    },
  },
}
</script>
